import type { ReactNode } from 'react'
import { cn } from '@/lib/utils'

interface MessageFooterProps {
  /** Omit to hide the time (e.g. agent messages). */
  timestamp?: Date
  className?: string
  children?: ReactNode
}

export function MessageFooter({
  timestamp,
  className,
  children,
}: MessageFooterProps) {
  return (
    <div
      data-slot="message-footer"
      className={cn('flex items-center gap-1 mt-1', className)}>
      {children}
      {timestamp && (
        <span className="ml-auto text-xs font-medium text-muted-foreground">
          {timestamp.toLocaleTimeString(undefined, {
            hour: 'numeric',
            minute: '2-digit',
          })}
        </span>
      )}
    </div>
  )
}
